import React, { InputHTMLAttributes } from 'react'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import { BiInfoCircle } from 'react-icons/bi'

export const CepInput = React.forwardRef<HTMLInputElement, Props>( ( { label, important, info, ...props }, ref ) => {
    return (
        <div>
            <label className='flex justify-between'>
                <div className='flex items-center'>
                    {label}
                    {important && <BiInfoCircle className='text-primary-dark ml-1' />}
                </div>
            </label>
            <TextInput {...props} require className='rounded-lg'/>
            <div className='text-gray-500 text-sm'>{info}</div>
        </div>
    )
})

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label: string,
    important?: boolean,
    info?:string
}
